<template>
  <popup-container buttonLabel="close">
    <template slot="header">
      {{ $l['message'] }}
    </template>

    <div class="message">
      {{ message.get('content') }}
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    PopupContainer
  },

  created: function () {
    this.$store.dispatch('message/read')
  },

  computed: {
    message: function () {
      return this.$store.state.message.message
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  display: flex;
  align-items: center;
  padding: 10px;
}
</style>
